import { render } from "./BlogSidebarInOnlays.vue?vue&type=template&id=0bd3e7bf"
import script from "./BlogSidebarInOnlays.vue?vue&type=script&lang=js"
export * from "./BlogSidebarInOnlays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__